/* eslint-disable no-param-reassign */
import axios from 'axios';
import { UNAUTHORIZED } from 'http-status';

import StorageService from '../../../services/storage';
import { routerStore } from '../../../stores/RouterStore';
import { refresh } from '../v1/auth';

const baseURL = process.env.REACT_APP_BACKEND_URL;

export const axiosInteceptor = () => {
  axios.interceptors.request.use(config => {
    if (config.baseURL === baseURL) {
      const token = StorageService.getAccessToken();

      if (token) {
        config.headers.Authorization = token;
      }
    }

    return config;
  });

  axios.interceptors.response.use(
    response => response,
    async error => {
      if (error.response) {
        // Retorna o erro diretamente quando for diferente de UNAUTHORIZED (401)
        if (error.response.status !== UNAUTHORIZED) {
          return new Promise((_, reject) => reject(error));
        }

        // Manda o usuário para tela de link expirado quando a rota for de autenticação ou
        // na mensagem retornada pela API conter 'Invalid Link'
        if (
          error.config.url === '/v2/auth' ||
          error.response.data.userMessage === 'Invalid Link'
        ) {
          StorageService.clearStorage();
          routerStore.push('/link-expirado');

          return new Promise((_, reject) => {
            reject(error);
          });
        }

        // Manda o usuário para tela de erro quando a rota for de refresh do token ou
        // na mensagem retornada pela API conter 'Código de refresh token é inválido'
        if (
          error.config.url === '/v1/auth/refresh' ||
          error.response.data.userMessage ===
            'Código de refresh token é inválido'
        ) {
          StorageService.clearStorage();
          routerStore.push('/error');

          return new Promise((_, reject) => {
            reject(error);
          });
        }

        // Se não for nenhuma das URL's acima, tenta realizar o refresh do token
        try {
          const response = await refresh(
            StorageService.getRefreshToken(),
            StorageService.getLinkUuid()
          );
          const {
            data: {
              records: [{ accessToken, refreshToken }],
            },
          } = response;

          StorageService.setAccessToken(accessToken);
          StorageService.setRefreshToken(refreshToken);

          // Faz a requisição novamente com o novo token
          const { config } = error;
          config.headers.Authorization = accessToken;

          return new Promise((resolve, reject) => {
            axios
              .request(config)
              .then(res => {
                resolve(res);
              })
              .catch(err => {
                reject(err);
              });
          });
        } catch (err) {
          return new Promise((_, reject) => {
            reject(err);
          });
        }
      }

      // Se não houver o response no objeto error, quer dizer que a API está down, então levamos o
      // usuário para a página de erro
      StorageService.clearStorage();
      routerStore.push('/error');

      return new Promise((_, reject) => {
        reject(error);
      });
    }
  );
};
